<template>
  <div class="v-application">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-top class="d-md-flex align-end" style="background-color: #EEF2F5; margin-bottom: 10px !important;">
          <template v-slot:body>
            <v-row no-gutters class="pa-2 pb-2">
              <v-col cols="12" class="d-flex font-weight-bold">
                <div class="content--text text-caption font-weight-bold">
                  <v-icon x-small>mdi-square-small</v-icon>
                  등록일자
                </div>
                <div class="primary--text text-caption font-weight-bold">{{ '\u00A0' + (selectedFileData ? selectedFileData.createdAt : '') }}</div>
              </v-col>
              <v-col cols="12" class="d-flex font-weight-bold">
                <div class="content--text text-caption font-weight-bold">
                  <v-icon x-small>mdi-square-small</v-icon>
                  이름
                </div>
                <div class="primary--text text-caption font-weight-bold">{{ '\u00A0' + (selectedFileData ? selectedFileData.fileNm : '') }}</div>
              </v-col>
              <v-col cols="12" md="4" class="d-flex font-weight-bold">
                <div class="content--text text-caption font-weight-bold">
                  <v-icon x-small>mdi-square-small</v-icon>
                  용량
                </div>
                <div class="primary--text text-caption font-weight-bold">{{ '\u00A0' + (selectedFileData ? selectedFileData.fileSize : '') }}</div>
              </v-col>
              <v-col cols="12" md="4" class="d-flex font-weight-bold">
                <div class="content--text text-caption font-weight-bold">
                  <v-icon x-small>mdi-square-small</v-icon>
                  확장자
                </div>
                <div class="primary--text text-caption font-weight-bold">{{ '\u00A0' + (selectedFileData ? selectedFileData.extension : '') }}</div>
              </v-col>
              <v-col cols="12" md="4" class="d-flex font-weight-bold">
                <div class="content--text text-caption font-weight-bold">
                  <v-icon x-small>mdi-square-small</v-icon>
                  다운로드
                </div>
                <v-btn elevation="0" color="btn_sub" dark x-small class="rounded ml-2" @click="fileDownload(selectedFileData.fileId)">
                  다운로드
                  <!-- <svg-icon icon-class="download" style="color: #3b50e2 !important;"></svg-icon> -->
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </i-card-top>
      </v-col>
      <v-col cols="12" class="d-flex justify-center">
        <div class="preview-zone ma-0">
          <div class="d-flex" v-if="isImageFile(selectedFileData.extension)">
            <v-btn text icon large @click="arrowButton('left')">
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <img :src="preview" />
            <v-btn text icon large @click="arrowButton('right')">
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
          <div class="d-flex" v-else>
            <v-btn text icon large @click="arrowButton('left')">
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <div class="not-image-msg">
              허용된 확장자가 아닙니다.
              <br />
              허용된 확장자 : {{ this.imageExtension.join() }}
            </div>
            <v-btn text icon large @click="arrowButton('right')">
              <v-icon>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { downloadFile } from '@/api/baseManage/fileUpload';
import iCardTop from '@/components/common/iCardTop.vue';
import baseview from '@/views/base/baseview.vue';
export default {
  mixins: [baseview], 
  name: 'i-preview',
  components: {
    'i-card-top': iCardTop
  },
  props: {
    fileList: {
      type: Array
    },
    propsFileData: {
      type: Object
    }
  },
  data() {
    return {
      preview: '',
      selectedFileData: {
        createdAt: '',
        fileNm: '',
        fileSize: '',
        extension: ''
      },
      imageExtension: ['jpg', 'jpeg', 'gif', 'png']
    }
  },
  mounted() {
    this.selectedFileData = this.propsFileData
    this.previewLoad()
  },
  methods: {
    previewLoad() {
      if (!this.isImageFile(this.selectedFileData.extension)) return

      this.openLoading()
      // api 에 responseType: "blob" 필수, 백단에 byteArray(Blob)형태로 보내고 있기 때문
      let params = {
        clntId: this.selectedFileData.clntId,
        writeDt: this.selectedFileData.writeDt,
        docNo: this.selectedFileData.docNo
      }
      downloadFile(params)
        .then(res => {
          // 객체를 만들어서 생성
          let objectUrl = window.URL.createObjectURL(res)
          this.preview = objectUrl
        })
        .finally(() => this.endLoading())
    },
    fileDownload() {
      this.openLoading()
      // api 에 responseType: "blob" 필수, 백단에 byteArray(Blob)형태로 보내고 있기 때문
      let params = {
        clntId: this.selectedFileData.clntId,
        writeDt: this.selectedFileData.writeDt,
        docNo: this.selectedFileData.docNo
      }
      downloadFile(params)
        .then(res => {
          let link = document.createElement('a')
          // 객체를 만들어서 생성
          let objectUrl = window.URL.createObjectURL(res)
          link.href = objectUrl
          link.download = `${this.selectedFileData.fileNm}.${this.selectedFileData.extension}`
          link.click()
        })
        .finally(() => this.endLoading())
    },
    arrowButton(direction) {
      let index = this.fileList.findIndex(element => element == this.selectedFileData)
      if (direction == 'left') {
        index -= 1
      } else if (direction == 'right') {
        index += 1
      }
      if (index < 0) index = this.fileList.length - 1
      if (index == this.fileList.length) index = 0

      console.log('fileList', this.fileList)

      this.selectedFileData = this.fileList[index]
      this.previewLoad()
    },
    isImageFile(extension) {
      return this.imageExtension.indexOf(extension) > -1
    }
  }
}
</script>

<style lang="scss" scoped>
  .preview-zone {
    width: 600px;
    height: 444px;
    margin: auto;
  }
  .preview-zone img {
    width: 520px;
    height: 444px;
    object-fit: contain;
  }
  .preview-zone .not-image-msg {
    width: 520px;
    height: 444px;
    justify-content: center;
    display: flex;
    align-items: center;
  }
  .preview-zone button {
    align-self: center;
  }
  .content--text::after {
    content: ':';
  }
</style>
